import http from "./Http";
import Service from "./Service";

export default class QuotationService extends Service {

  	getProviderProductsForCurrentClient(provider_id, data) {
		return http.get(`providers/products/${provider_id}`, {
			headers: this.getHeaders(),
			params: data
		});
  	}

	getRequestTempProducts(data) {
		return http.get("listarprodutosrequisicaotemporaria", {
			headers: this.getHeaders(),
			timeout: 600000,
			params: data
		});
	}

	clearRequestTempProducts(type) {
		return http.delete("limparprodutosrequisicaotemporaria", {
			headers: this.getHeaders(),
			params: {type}
		});
	}

	getDirectSaleOrders(params) {
		return http.get("orders", {
			headers: this.getHeaders(),
			params: params
		});
	}

	findOrdersByQuotationId(quotationId, fornecedor = undefined, seller = undefined, page = 1) {
		return http.get("listarpedidos", {
			params: { numerocotacao: quotationId, singleorder: true, fornecedor: fornecedor, loja: seller, page},
			headers: this.getHeaders()
		});
	}

	// findOrdersByStore()

	getDirectSaleOrder(id) {
		return http.get(`orders/${id}`, {
			headers: this.getHeaders()
		});
	}

    get_order_data(order){
		return http.get("getorderdatanew", {
			headers: this.getHeaders(),
			timeout: 600000,
			params: {
				id_pedido: order.id_pedido,
				numeroCotacao: order.id_cotacao,
				loja: order.id_loja,
				id_vendedor: order.usu_id
			}
		});
	}

	exportPdfOrder(order){
		return http.get("gerarpdfpedido", {
			headers: this.getHeaders(),
			timeout: 600000,
			responseType: 'arraybuffer',
			params: {
				id_pedido: order.id_pedido,
				numeroCotacao: order.id_cotacao,
				loja: order.id_loja,
				id_vendedor: order.usu_id
			}
		});
	}
	getStores(){
		const config = {
			headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
		};
		return http.get(`/getrequisitantescliente`, config)
	}
}
